"use client";

import { useConsentManagementVisibility } from "@aleksundshantu/aunds-cookie-plugin-react";

type ConsentManagementButtonProps = {
  title: string;
  className?: string;
};

/**
 * Reopens the consent management popup. The visible menu item title is the
 * accessible name, so no aria-label overrides it (WCAG 2.5.3 label in name).
 */
export const ConsentManagementButton = ({
  title,
  className = "",
}: ConsentManagementButtonProps) => {
  const { show: showConsentManagement } = useConsentManagementVisibility();

  return (
    <button
      type="button"
      className={`button-reset ${className}`}
      onClick={showConsentManagement}
    >
      {title}
    </button>
  );
};
